import { HttpService } from '../../../services/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { InvestmentsQueryParams } from '../../../shared/interfaces/investments-query-params';
import { InvestmentsResponseInterface } from '../../../shared/interfaces/investments-response.interface';
import { InvestorInterface, InvestorsDistinctFilterValuesInterface } from 'src/app/shared/interfaces/Investors-distinct-filter-values.interface';
import { InvestorsByIdResponseInterface, InvestorsResponseInterface } from 'src/app/shared/interfaces/Investors-response.interface';
import { Summary } from 'src/app/shared/interfaces/base-response-interface';
import { InvestorsQueryParams } from 'src/app/shared/interfaces/investors-query-params';

@Injectable({
  providedIn: 'root',
})
export class FinancialStatementHttpService extends HttpService {
  getFinancialStatementData(params: Partial<InvestmentsQueryParams>): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}financial-statements`, {
      params: this.queryCleaner(params),
    });
  }

  getFinancialStatementSummary(params: Partial<InvestmentsQueryParams>): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}financial-statements/summary`, {
      params: this.queryCleaner(params),
    });
  }

  getFinancialStatementsDataByID(params: Partial<InvestmentsQueryParams>): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}financial-statements/generate-by/${params.investorId}`, {
      params: this.queryCleaner(params),
    });
  }

  getInvestorsFilterData(): Observable<InvestorsDistinctFilterValuesInterface> {
    return this.http.get<InvestorsDistinctFilterValuesInterface>(`${this.baseUrl}Investors/distinct-filter-values`);
  }

  getCurrencyFilterData(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}currencies`);
  }

  getInvestorsData(params: Partial<InvestorsQueryParams>): Observable<InvestorsResponseInterface> {
    const baseUrl = this.baseUrl + 'Investors';
    return this.http.get<InvestorsResponseInterface>(baseUrl, {
      params: this.queryCleaner(params),
    });
  }

  getInvestmentsData(params: Partial<InvestmentsQueryParams>): Observable<InvestmentsResponseInterface> {
    const baseUrl = this.baseUrl + 'investments';
    return this.http.get<InvestmentsResponseInterface>(baseUrl, {
      params: this.queryCleaner(params),
    });
  }

  getInvestorsSummary(params: Partial<InvestorsQueryParams>): Observable<Summary> {
    return this.http.get<Summary>(`${this.baseUrl}Investors/summary`, {
      params: this.queryCleaner(params),
    });
  }

  addInvestor(investorData: InvestorInterface): Observable<any> {
    return this.http.post(`${this.baseUrl}investors`, investorData, { headers: this.getHeaders() });
  }

  getInvestorById(id: string): Observable<any> {
    return this.http.get<InvestorsByIdResponseInterface>(`${this.baseUrl}investors/${id}`, { headers: this.getHeaders() });
  }
}
